import styled from '@emotion/styled';

export const PageLayout = styled.div`
  display: flex;
  gap: 32px;
  padding: 24px 0;
`;

export const LeftSidebar = styled.aside`
  width: 260px;
  flex-shrink: 0;
  top: 72px;
  align-self: flex-start;
  max-height: calc(100vh - 88px);
`;

export const MainContent = styled.div`
  flex: 1;
  min-width: 0;
`;
